import Swiper from "swiper"
import { Navigation, Pagination, Autoplay } from "swiper/modules"

const arrow = `<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 12.1 22.7" style="enable-background:new 0 0 12.1 22.7;" xml:space="preserve"><path d="M10.6,11.4L0,0.7L0.7,0l11.4,11.4L0.7,22.7L0,22L10.6,11.4z"/></svg>`
const arrowBig =
  '<svg xmlns="http://www.w3.org/2000/svg" id="svg4" width="24" height="24" viewBox="0 0 96 96" fill="none" version="1.1"><path id="path2" fill="#1f2323" fill-rule="evenodd" d="M69.4144 36.1716c.7808.781.7808 2.0474 0 2.8284L48 60.4142 26.5858 39c-.781-.781-.781-2.0474 0-2.8284.781-.781 2.0474-.781 2.8284 0L48 54.7574l18.5856-18.5858c.7812-.781 2.0476-.781 2.8288 0z" clip-rule="evenodd" style="stroke-width:4"/></svg>'
const autoplayCircle = `<svg class="circle" height="20" width="20"><circle cx="10" cy="10" r="6"/></svg>`

/** Create navigation elements before init slider
 * @param {HTMLElement} buttonsContainer - container for navigation elements
 * @param {string} options.arrow - e.g. svg html string
 * @returns
 */
export const createNav = (buttonsContainer, options) => {
  if (!buttonsContainer) return {}

  const createNavElement = (direction) => {
    const el = document.createElement("button")
    el.className = `slick-${direction} slick-arrow flex-c-c product-slider__${direction}`
    el.innerHTML = options.arrow
    const ariaLabelPhrase = window.phrases?.[direction]
    if (ariaLabelPhrase) {
      el.ariaLabel = ariaLabelPhrase
    }
    const existingEl = buttonsContainer.querySelector(`.product-slider__${direction}`)
    return existingEl || buttonsContainer.appendChild(el)
  }

  return { prevEl: createNavElement("prev"), nextEl: createNavElement("next") }
}

export const renderBullet = (index, className) =>
  `<li class="${className}">
    <button type="button">${index}</button>
  </li>`

let productSliderObj
export const productSlider = () => {
  const productSliders = document.querySelectorAll(".product-slider")

  if (window.innerWidth < 600 && productSliderObj) {
    // Check if productSliderObj is array then destroy all sliders
    if (Array.isArray(productSliderObj)) {
      productSliderObj.forEach((sl) => sl.destroy())
    } else {
      productSliderObj.destroy()
    }
    productSliderObj = null
  } else if (window.innerWidth >= 600 && !productSliderObj) {
    productSliderObj = Array.from(productSliders).map((slider) => {
      const { prevEl, nextEl } = createNav(slider.querySelector(".wb-title"), { arrow })

      return new Swiper(slider.querySelector(".js_product_slider"), {
        modules: [Navigation],
        wrapperClass: "js_product_slider_wrapper",
        slideClass: "product-card",
        watchSlidesProgress: true,
        slideVisibleClass: "product-card--visible",
        init: true,
        navigation: {
          enabled: true,
          disabledClass: "slick-disabled",
          nextEl,
          prevEl,
        },
        breakpoints: {
          600: {
            slidesPerView: 2.5,
          },
          960: {
            slidesPerView: 3,
          },
          1250: {
            slidesPerView: 4,
          },
          1440: {
            slidesPerView: 5,
          },
        },
      })
    })
  }
}

const sliders = () => {
  const banner = () => {
    const bannerSlider = new Swiper(".banner", {
      modules: [Pagination, Autoplay],
      loop: true,
      speed: 800,
      wrapperClass: "banner__slider",
      slideClass: "banner-card",
      slidesPerView: 1,
      autoplay: {
        delay: 5000,
        disableOnInteraction: false,
        waitForTransition: false,
      },
      pagination: {
        el: ".banner__dots",
        clickable: true,
        bulletElement: "li",
        bulletActiveClass: "slick-active",
        renderBullet: (index, className) =>
          `<li class="${className}">${autoplayCircle}</li>`,
      },
    })
  }

  let blogSliderObj
  const responseBlog = () => {
    const blogSlider = document.querySelector(".block-news__content .swiper")
    if (!blogSlider) return
    if (window.innerWidth >= 1250 && blogSliderObj) {
      // Check if blogSliderObj is array then destroy all sliders
      if (Array.isArray(blogSliderObj)) {
        blogSliderObj.forEach((sl) => sl.destroy())
      } else {
        blogSliderObj.destroy()
      }
      blogSliderObj = null
    } else if (window.innerWidth < 1250 && !blogSliderObj) {
      blogSliderObj = new Swiper(blogSlider, {
        modules: [Pagination],
        wrapperClass: "swiper-wrapper",
        slideClass: "news-card",
        slidesPerView: 1,
        pagination: {
          el: ".slick-dots",
          renderBullet,
          bulletActiveClass: "slick-active",
        },
        breakpoints: {
          510: {
            slidesPerView: 2,
          },
          960: {
            slidesPerView: 3,
          },
        },
      })
    }
  }

  responseBlog()
  banner()
  productSlider()

  // Debounce resize event
  let resizeTimeout
  window.addEventListener("resize", () => {
    clearTimeout(resizeTimeout)
    resizeTimeout = setTimeout(() => {
      productSlider()
      responseBlog()
    }, 200)
  })
}

export const categorySliderSettings = {}

let categorySliderObj

// Init only on desktop. Use matchMedia so JS stays in lockstep with the
// SCSS `lg` breakpoint (960px); window.innerWidth can disagree with the CSS
// viewport on mobile and init the slider when it shouldn't.
const syncCategorySliderState = (isDesktop) => {
  const sliderContainer = document.querySelector(".catalogue-categories .swiper")

  if (!sliderContainer || !isDesktop) {
    if (categorySliderObj) {
      categorySliderObj.destroy(true, true)
      categorySliderObj = null
      // destroy() leaves the nav buttons createNav appended to the container
      sliderContainer
        ?.querySelectorAll(".product-slider__prev, .product-slider__next")
        .forEach((el) => el.remove())
    }
    return
  }

  if (categorySliderObj) return

  const { nextEl, prevEl } = createNav(sliderContainer, { arrow: arrowBig })

  categorySliderObj = new Swiper(".catalogue-categories .swiper", {
    modules: [Navigation],
    wrapperClass: "js_catalogue_categories_root",
    slideClass: "catalogue-categories__item",
    observer: true,
    init: true,
    slidesPerView: "auto",
    navigation: {
      enabled: true,
      disabledClass: "slick-disabled",
      nextEl,
      prevEl,
    },
  })
}

export const categorySlider = () => {
  const desktopQuery = window.matchMedia("(min-width: 960px)")
  syncCategorySliderState(desktopQuery.matches)
  desktopQuery.addEventListener("change", (e) => syncCategorySliderState(e.matches))
}

export const jobValuesSlider = () => {
  if (window.innerWidth > 1250) return
  const jobValuesSlider = new Swiper(".js_values_info_slider", {
    modules: [Pagination, Autoplay],
    loop: true,
    autoplay: {
      delay: 5000,
      disableOnInteraction: false,
      waitForTransition: false,
    },
    // wrapperClass: "values-info-list",
    slideClass: "values-info-list__item",
    slidesPerView: 1,
    pagination: {
      el: ".banner__dots",
      clickable: true,
      bulletElement: "li",
      bulletActiveClass: "slick-active",
      renderBullet: (index, className) =>
        `<li class="${className}">${autoplayCircle}</li>`,
    },
  })
}

export const jobTeamSlider = () => {
  const jobTeamSlider = new Swiper(".js_team_slider", {
    modules: [Autoplay, Pagination],
    wrapperClass: "team-list",
    slideClass: "team-list__item",
    slidesPerView: "auto",
    autoplay: {
      delay: 5000,
      disableOnInteraction: false,
      waitForTransition: false,
    },
    pagination: {
      el: ".banner__dots",
      dynamicBullets: true,
      clickable: true,
      bulletElement: "li",
      bulletActiveClass: "slick-active",
      renderBullet: (index, className) =>
        `<li class="${className}">${autoplayCircle}</li>`,
    },
  })
}


export default sliders
